import { render } from "./VendorsWithdrawalsIndexTable.vue?vue&type=template&id=a65e9e26"
import script from "./VendorsWithdrawalsIndexTable.vue?vue&type=script&lang=js"
export * from "./VendorsWithdrawalsIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__